module.exports = __webpack_public_path__ + "static/media/personal-info.f7d86e74.svg";